// Czyste helpery formatujące cennik — bez React, łatwe do testów.
// Wszystkie funkcje defensywne: złe/niekompletne dane nie wywalają aplikacji.

/**
 * "100.00" -> "100 PLN", "99.50" -> "99,50 PLN".
 * Obcina grosze tylko gdy równe zeru; zachowuje gdy realne.
 */
export function formatCena(raw) {
    const value = parseFloat(raw);
    if (!Number.isFinite(value)) return '';
    const hasGrosze = Math.round(value * 100) % 100 !== 0;
    const text = hasGrosze
        ? value.toFixed(2).replace('.', ',')
        : String(Math.round(value));
    return `${text} PLN`;
}

/**
 * 1 -> "1 dzień", pozostałe -> "N dni".
 */
export function formatDni(n) {
    const days = parseInt(n, 10);
    if (!Number.isFinite(days)) return '';
    return days === 1 ? '1 dzień' : `${days} dni`;
}

/**
 * Odtwarza obecne podświetlenia (1, 7, 14, 21...) bez sztywnej listy:
 * pierwszy dzień oraz pełne tygodnie.
 */
export function isHighlight(dni) {
    const days = parseInt(dni, 10);
    if (!Number.isFinite(days)) return false;
    return days === 1 || days % 7 === 0;
}

/**
 * Normalizuje pojedynczy cennik:
 * - parsuje i sortuje po ilosc_dni rosnąco,
 * - jeśli ostatnia pozycja ma cenę NIŻSZĄ niż poprzednia, traktuje ją jako
 *   marker dopłaty "kolejna doba" (konwencja z bazy: np. dzień 17 = 10.00),
 *   zdejmuje z wierszy i zwraca jako surcharge.
 * Brak markera -> surcharge: null (wiersz alt ukryty).
 */
export function extractSurcharge(cenniki) {
    const rows = (Array.isArray(cenniki) ? cenniki : [])
        .map((c) => ({ dni: parseInt(c?.ilosc_dni, 10), cena: parseFloat(c?.cena) }))
        .filter((r) => Number.isFinite(r.dni) && Number.isFinite(r.cena))
        .sort((a, b) => a.dni - b.dni);

    if (rows.length >= 2) {
        const last = rows[rows.length - 1];
        const prev = rows[rows.length - 2];
        if (last.cena < prev.cena) {
            return { rows: rows.slice(0, -1), surcharge: last.cena };
        }
    }
    return { rows, surcharge: null };
}

/**
 * Dzieli wiersze na dwie kolumny — lewa = pierwsza połowa, prawa = druga.
 * Odtwarza layout 1-8 / 9-16, działa dla dowolnej liczby dni (nieparzysta ->
 * lewa kolumna dłuższa o 1).
 */
export function splitColumns(rows) {
    const half = Math.ceil(rows.length / 2);
    return [rows.slice(0, half), rows.slice(half)];
}
